import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { withRouter } from '../../helpers/withRouter';

// Components
import Aside from "../../components/Aside";
import BubbleBg from "../../components/BubbleBg";
import Spinner from "../../components/Spinner";

// Actions
import {
  fetchProcedureCreate,
  fetchOrganizationGetAssessments,
  fetchProceduresIndex,
  fetchOrganization,     
  fetchOrganizations,
} from "../../redux/admin/actions";


// Selectors
import { getOrganization, getOrganizations } from "../../helpers/checkOrganization";
import ProcedureNewStepOne from "./ProcedureNewStepOne"
import ProcedureNewStepTwo from "./ProcedureNewStepTwo"
import ProcedureNewStepThree from "./ProcedureNewStepThree"
import ProcedureNewStepFour from "./ProcedureNewStepFour"

const ProcedureNew = (props) => {
  const [loading, setLoading] = useState(false);
  const [biodataOptions, setBiodataOptions] = useState([]);
  const [editData, setEditData] = useState({});
  const [step, setStep] = useState(1)
  const [totalSteps, setTotalSteps] = useState(2)
  const [modalMsg, setModalMsg] = useState("");
  const [modals, setModals] = useState("");

useEffect(() => {
  if (!props.organization?.data) return;

  let bio = props.organization.data.biodata_options.map(option => ({ ...option }));
  if (bio.filter((e) => e.value === "email").length === 0) {
    bio.unshift({ text: "Password", value: "password" });
    bio.unshift({ text: "Email", value: "email" });
    if (props.organization.data.id !== 125) {
      bio = bio.filter((e) => e.value !== "uax_courses" && e.value !== "uax_current_course");
    }
    setBiodataOptions(bio);
  }
}, [props.organization?.data?.id]);

useEffect(() => {
  if (!props.organizations || props.organizations.length === 0) {
    props.fetchOrganizations();
  }

  if (
    !props.organization?.data ||
    "" + props.organization.data.id !== "" + props.router.params.organizationId
  ) {
    props.fetchOrganization(props.router.params.organizationId, 1, 5000, () => {}, true);
  }

  props.fetchOrganizationGetAssessments(props.router.params.organizationId, () => {});

  return () => localStorage.removeItem("editData");
}, []);

  const submitCreate = (data) => {
    setLoading(true);
    data["title"] = data["name"];
    delete data["name"];
    props.fetchProcedureCreate(
      props.router.params.organizationId,
      data,
      () => {
        props.navigate(`/admin/organizations/${props.router.params.organizationId}/procedures`);
        setModals("success");
          setModalMsg("The process has been created successfully!");
          props.fetchProceduresIndex(props.router.params.organizationId, 1, 5000, () =>
            setLoading(false),
          );
      },
      () => "",
    );
  };

  const getAssessments = () => {
    props.navigate(`/admin/organizations/${props.router.params.organizationId}/procedure/new`);

    // let bio = props.organization.data.biodata_options
    // if(bio.filter((e) => e.value === "email").length == 0){
    //   bio.unshift({text: "Password", value: "password"})
    //   bio.unshift({text: "Email", value: "email"})
    //   if(props.organization.data.id !== 125){
    //     bio = bio.filter((e) => e.value !== "uax_courses" && e.value !== "uax_current_course")
    //   }
    //   setBiodataOptions(bio)
    // }

    // props.fetchOrganizationGetAssessments(
    //   props.router.params.organizationId,
    //   () => actionModals({}, "createProcedure")
    // );
  }

  const selectAction = (id) => {
    props.navigate(`/admin/organizations/${id}/procedures`);
  };

  const handleSetEditData = (data) => {
    localStorage.setItem("editData", JSON.stringify(data))
    setEditData(data)
  }

  const handleSetStep = (step) => {
    const dataStored = localStorage.getItem("editData")
    setEditData(JSON.parse(dataStored))
    setStep(step)
  }

  return (
    <motion.section
      className="o-wrapper"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >

      {loading && <Spinner />}
      <BubbleBg />

      {props.organizations &&
        props.organizations.length > 0 &&
        props.organization &&
        props.organization.data && (
          <Aside
            history={props.history}
            label={"Select organization:"}
            showSelect={true}
            organizations={props.organizations && props.organizations}
            organization={props.organization}
            selectAction={(id) => selectAction(id)}
            createOrganization={() => getAssessments()}
            selectOrganization={() => setModals("selectOrganization")}
            showModalSession={() => {
              setModals("closeSession"); setModalMsg("Are you sure you want to logout?");
            }}
          />
        )}

      <div className="o-container o-container--overflow-disabled">

        <h1 className="o-text-align o-text-align--left o-pos-rel" style={{ maxWidth: 768 }}>
          Procedure Create
          <span style={{
            fontSize: 18,
            right: 0,
            top: 0,
            position:'absolute', 
          }}>{step} / {totalSteps}</span>
        </h1>

        {
          props.organization?.data &&
           <>
            {step === 1 && (
              <ProcedureNewStepOne 
                editData={editData} 
                setEditData={(data) => handleSetEditData(data)}
                setStep={(step) => handleSetStep(step)}
                addStep={(amount) => setTotalSteps(totalSteps + 1)}
                removeStep={(amount) => setTotalSteps(totalSteps - 1)}
              />
            )}
            {step === 2 && (
              <ProcedureNewStepTwo
                setStep={(step) => handleSetStep(step)}
                biodataOptions={biodataOptions}
                setBiodataOptions={(bio) => setBiodataOptions(bio)}
                defaultData={props.procedure}
                editData={editData}
                setEditData={(data) => handleSetEditData(data)}
                assessments={props.organization.data.assessments.filter((e) => e.combined === false)}
                combined={props.organization.data.assessments.filter((e) => e.combined === true)}
                totalSteps={totalSteps}
                sendData={() => submitCreate(editData)}
              />
            )}
            {step === 3 && editData.licenses && (
              <ProcedureNewStepThree
                setStep={(step) => handleSetStep(step)}
                editData={editData}
                setEditData={(data) => handleSetEditData(data)}
                sendData={() => submitCreate(editData)}
                totalSteps={totalSteps}
              />
            )}
            {step === (totalSteps === 3 ? 3 : 4) && editData.consent_enabled && (
              <ProcedureNewStepFour
                setStep={(step) => handleSetStep(step)}
                editData={editData}
                setEditData={(data) => handleSetEditData(data)}
                sendData={() => submitCreate(editData)}
                totalSteps={totalSteps}
              />
            )}
           </>
        }

        

      </div>

      {loading && <Spinner />}

    </motion.section>
  )
};

ProcedureNew.propTypes = {

};

const mapStateToProps = (state, props) => {
  return {
    procedure: state.admin.procedure,
    organization: getOrganization(state, props),
    organizations: getOrganizations(state, props),
    assessments: state.admin.assessments,
    organizations_select: state.admin.organizations_select,
  };
};

const mapDispatchToProps = {
  fetchProcedureCreate,
  fetchOrganizationGetAssessments,
  fetchProceduresIndex,
  fetchOrganization,    
  fetchOrganizations,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProcedureNew));
